import React, { useState } from "react";
import styled from "styled-components";
import { IconError } from "../../Assets/IconError";
import { IconEye } from "../../Assets/IconEye";
import { IconEyeslash } from "../../Assets/IconEyeslash";
import { Tooltip } from "./Tooltip";
import { convertNumToEn } from "../Functions/Helpers";
import { formatPrice, removeFormatPrice } from "../Functions/Price";

const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  &.ltr-all {
    .text-field {
      &.ltr-help {
        padding: calc(var(--fs-textfield) * 2.3) calc(3rem - 1px) calc(var(--fs-textfield) * 0.7) calc(1rem - 1px);
      }
    }
    .eye {
      left: auto;
      right: calc(var(--fs-textfield) * 1.5);
    }
    .label-textinput{
      right: auto;
      left: 1rem;
    }
    .help-input{
      left: auto;
      right: calc(var(--fs-textfield) * 1.5);
      &.password {
        left: auto;
        right: calc(var(--fs-textfield) * 3.5);
      }
    }
  }
  .text-field {
    z-index: 3;
    width: calc(100% - 2rem);
    padding: calc(var(--fs-textfield) * 2.3) calc(1rem - 1px) calc(var(--fs-textfield) * 0.7);
    border-radius: var(--border-radius-2);
    border: 1px var(--n-grey-2) solid;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background: transparent;
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      text-align: left;
      direction: ltr;
     
    }
    &.ltr-help {
      width: calc(100% - 4rem);
      padding: calc(var(--fs-textfield) * 2.3) calc(1rem - 1px) calc(var(--fs-textfield) * 0.7) calc(3rem - 1px);
    }
    &.center-text {
      text-align: center;
      direction: ltr;
    }
    &.disabled {
      background-color: var(--n-grey-01);
      color: var(--n-grey-5);
    }
    :focus {
      border: 1px var(--n-grey-15) solid;
    }
  }
  .eye {
    cursor: pointer;
    position: absolute;
    z-index: 5;
    top: calc(var(--fs-textfield) * 1.5);
    left: calc(var(--fs-textfield) * 1.5);
  }
  .label-textinput{
    z-index: 2;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.5);
    right: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    &.disabled {
      color: var(--n-grey-5);
    }
  }
  .text-field:focus + .label-textinput {
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    font-size: calc(var(--fs-textfield) * 0.8);
  }
  .text-field:not([value=""]) + .label-textinput {
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    font-size: calc(var(--fs-textfield) * 0.8);
  }
  .help-input{
    z-index: 5;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.35);
    left: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    .icon {
      width: 24px;
      transition: var(--trans-1);
    }
    &.password {
      left: calc(var(--fs-textfield) * 3.5);
    }
    .helpText{
      z-index: 5;
    }
  }
  .help-pass {
    padding: 0.3rem 0.3rem 0;
    font-size: var(--fs-small);
  }
  .error {
    display: flex;
    align-items: center;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0.1rem 0.2rem 0 0;
      color: red;
    }
  }
  @media screen and (max-width: 1445px) {
    &.ltr-all {
      .text-field {
        &.ltr-help {
          padding: calc(var(--fs-textfield) * 1.6) calc(3rem - 1px) calc(var(--fs-textfield) * 0.5) calc(1rem - 1px) ;
        }
      }
      .eye {
        left: auto;
        right: calc(var(--fs-textfield) * 1.05);
      }
      .label-textinput{
        right: auto;
        left: 1rem;
      }
      .help-input{
        left: auto;
        right: calc(var(--fs-textfield) * 1.05);
      }
    }
    .text-field {
      padding: calc(var(--fs-textfield) * 1.6) calc(1rem - 1px) calc(var(--fs-textfield) * 0.5);
      &.ltr-help {
        padding: calc(var(--fs-textfield) * 1.6) calc(1rem - 1px) calc(var(--fs-textfield) * 0.5) calc(3rem - 1px);
      }
    }
    .eye {
      top: calc(var(--fs-textfield) * 1.05);
      left: calc(var(--fs-textfield) * 1.05);
    }
    .label-textinput{
      top: calc(var(--fs-textfield) * 1.05);
      right: calc(var(--fs-textfield) * 1.05);
    }
    .text-field:focus + .label-textinput {
      top: calc(var(--fs-textfield) * 0.3);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
    .text-field:not([value=""]) + .label-textinput {
      top: calc(var(--fs-textfield) * 0.3);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
    .help-input{
      top: calc(var(--fs-textfield) * 0.95);
      left: calc(var(--fs-textfield) * 1.05);
    }
  }
  
`;

// dokme chesm baray ramz ha
export const TextInputWTitle = ({
  style,
  name,
  type = "text",
  error,
  value,
  onchange,
  title,
  required,
  ltr,
  center,
  onEnter,
  help,
  disabled,
  lan=false,
  price= false
}) => {
  const onChangeBase = (e) => {
    e.target.value = convertNumToEn(e.target.value);
    if(price){
      e.target.value = removeFormatPrice(e.target.value);
    }
    onchange(e);
  }
  const [showPass, setShowPass] = useState(false);
  if(price){
    value = value ? formatPrice(value) : "";
  }




  let errorComp = "";
  let classes = "text-field";
  if (error && error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <React.Fragment>
        <IconError />
        <div className="text">{error}</div>
      </React.Fragment>
    );
  }

  if (ltr) {
    classes += " ltr-text";
  }

  if (center) {
    classes += " center-text";
  }
  if (disabled) {
    classes += " disabled";
  }
  //
  let iconEye = "";
  if (type === "password") {
    if (showPass) {
      iconEye = (
        <div className="eye" onClick={() => setShowPass(false)}>
          <IconEyeslash />
        </div>
      );
    } else {
      iconEye = (
        <div className="eye" onClick={() => setShowPass(true)}>
          <IconEye />
        </div>
      );
    }
  }
  function handleKeyPress(e) {
    if (e.key === "Enter") {
      if (typeof onEnter === "function") {
        onEnter();
      }
    }
  }
  let helpElement = '';
  let helpElementPass = '';
  if((help) && !(type === "password")){
    classes += " ltr-help";
    helpElement = (
      <Tooltip ClassTooltip={"help-input"} ClassText={'helpText'} width="15rem" right={'-7.5rem'}>
        {help}
      </Tooltip>
    );
  } else if(help) {
    helpElementPass = (
      <div className="help-pass">
        {help}
      </div>
    )
  }

  return (
    <Styles style={style} className={(lan) ? "ltr-all" : ""}>
      <input
        onKeyPress={handleKeyPress}
        className={classes}
        name={name}
        type={showPass ? "text" : type}
        value={value}
        onChange={onChangeBase}
        required={required}
        disabled={disabled}
      />
      <label className={"label-textinput " + ((disabled) ? 'disabled' : '')}>
        {title}
      </label>
      {helpElement}
      {iconEye}
      {helpElementPass}
      <div className="error">{errorComp}</div>
    </Styles>
  );
};
